export default {"src":"/_next/static/media/JointInstability.1e0055cb.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};